import React, { useEffect, useState } from 'react'
import { styles } from './AdvertisementItem-styles'
import Icon from 'blocks.simple/icon/icon'
import { Typography } from '../../../../../../atoms/Typography'
import { DownloadItemView } from '../DownloadItem/DownloadItem-view'
import { api } from '../../../../../../core/api/ConnectionManager'

export const AdvertisementItemView = ({
    advertisementData,
    isOpened,
    advertisementHandleClick,
    digitalSignageId,
}: any) => {
    const [advertisementFilesList, setAdvertisementFilesList] = useState<any>([])
    const { advertisementId, name, downloadedPercent, status } = advertisementData
    const listenersId: any = []

    const renderStatus = (status: string) => {
        switch (status) {
            case 'downloading':
                return <Typography>{downloadedPercent}%</Typography>
            case 'downloaded':
                return <Icon type="done" color="#1EC686" />
            case 'downloadedMultiply':
                return <Icon type="doneMultiply" color="#1EC686" />
            case 'error':
                return <Icon type="errorWarning" color="#D61750" />
        }
    }

    const getAdvertisementListInfo = () => {
        api.send('requestAdvertisementsInfoWithFiles', {
            digitalSignageId,
            advertisementId,
        })
    }

    useEffect(() => {
        api.addObserver(
            'advertisementsInfoWithFilesSent',
            (data: any) => {
                if (!data) return

                if (
                    data.advertisement.advertisementId === advertisementId &&
                    data.digitalSignageId === digitalSignageId
                ) {
                    setAdvertisementFilesList(data.advertisement.files)
                }
            },
            listenersId
        )

        return () => {
            listenersId.forEach((id: any) => api.removeObserver(id))
        }
    }, [])

    useEffect(() => {
        if (!isOpened) {
            if (advertisementFilesList.length) {
                setAdvertisementFilesList([])
            }

            return
        }

        if (digitalSignageId && advertisementId) {
            getAdvertisementListInfo()
        }
    }, [isOpened, advertisementData])

    return (
        <li className={styles.advertisementItem} onClick={() => advertisementHandleClick(advertisementId)}>
            <div className={styles.advertisementItemHeader}>
                <div className={styles.advertisementItemLeft}>
                    <Icon type="advertisementItem" color="#b3b3b3" className={styles.icon} />
                    <Icon
                        type="openArrow"
                        color="#b3b3b3"
                        className={`${styles.icon} ${isOpened ? styles.opened : ''}`}
                    />
                    <Typography className={styles.advertisementName}>{name}</Typography>
                </div>
                <div className={styles.advertisementItemRight}>
                    <div className={styles.status}>{renderStatus(status)}</div>
                </div>
            </div>
            <ul>
                {advertisementFilesList.map((advertisementFile: any, index: number) => (
                    <DownloadItemView key={index} broadcastFile={advertisementFile} />
                ))}
            </ul>
        </li>
    )
}
